import CreditCardRoundedIcon from "@mui/icons-material/CreditCardRounded";

export default function PaymentHistoryPanel({ payments }) {
  if (!payments || payments.length === 0) {
    return (
      <section className="mt-6">
        <p className="text-[var(--color-text-muted)] xl:text-sm text-xs font-bold uppercase tracking-[0.08em] mb-4">
          Payment History
        </p>
        <div className="relative bg-[var(--color-surface)] border border-[var(--color-border)] rounded-[var(--radius-md)] flex flex-col items-center justify-center text-center p-8 min-h-[220px]">
          <div className="w-14 h-14 rounded-[var(--radius-md)] inline-flex items-center justify-center shrink-0 bg-[rgba(200,255,0,0.12)] text-[var(--color-primary)] border border-[rgba(200,255,0,0.25)] mb-4">
            <CreditCardRoundedIcon sx={{ fontSize: 28 }} />
          </div>
          <h3 className="m-0 text-[var(--color-text)] xl:text-xl md:text-lg text-base font-bold mb-1">
            No Payment History Found
          </h3>
          <p className="m-0 text-[var(--color-text-muted)] xl:text-base md:text-sm text-xs leading-[1.5]">
            There are no past payment or billing transactions recorded for your account.
          </p>
        </div>
      </section>
    );
  }

  return (
    <section className="mt-6">
      <p className="text-[var(--color-text-muted)] xl:text-sm text-xs font-bold uppercase tracking-[0.08em] mb-4">
        Payment History
      </p>
      <div className="relative bg-[var(--color-surface)] border border-[var(--color-border)] rounded-[var(--radius-md)] grid gap-0 p-4">
        {payments.map((payment, index) => (
          <div className="relative flex md:flex-row flex-col md:items-center items-start justify-between gap-4 py-5 px-0 first:pt-0 last:pb-0" key={payment.id}>
            <div className="flex items-center gap-4 min-w-0">
              <div className="w-14 h-14 rounded-[var(--radius-md)] inline-flex items-center justify-center shrink-0 bg-[rgba(200,255,0,0.12)] text-[var(--color-primary)] border border-[rgba(200,255,0,0.25)]">
                <CreditCardRoundedIcon sx={{ fontSize: 24 }} />
              </div>

              <div className="min-w-0">
                <h3 className="xl:text-lg md:text-base text-sm">{payment.planName}</h3>
                <p className="text-[var(--color-text-muted)] xl:text-base md:text-sm text-xs mt-1.5">{payment.paidAt}</p>
              </div>
            </div>

            <div className="flex flex-col md:w-auto w-full md:text-right text-left md:items-end items-start gap-3 shrink-0">
              <strong className="xl:text-lg md:text-base text-sm">{payment.amount}</strong>
              <span className="inline-flex items-center justify-center min-h-[34px] rounded-full px-3 bg-[rgba(200,255,0,0.12)] text-[var(--color-primary)] border border-[rgba(200,255,0,0.25)] xl:text-base md:text-sm text-xs font-bold">{payment.status}</span>
            </div>

            {index < payments.length - 1 && <div className="absolute left-0 right-0 bottom-0 m-0 h-[1px] bg-[var(--color-border)]" />}
          </div>
        ))}
      </div>
    </section>
  );
}
